import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import InputMask from "react-input-mask";
import Checkbox from "@material-ui/core/Checkbox";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { userHasRole } from "../../auth/UserFunctions";
import NumberFormat from "react-number-format";
import ViewIcon from "@material-ui/icons/Visibility";
import Link from "@material-ui/core/Link";

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      //      mask={['(', /[0-9]/, /\d/, /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      //      placeholderChar={'\u2000'}
      mask="(+99) - 99999 - 99999999"
      formatChars={{ "9": "[0-9]", "-": "[0-9-]", "?": "[0-9 ]" }}
      placeholderChar={"\u2000"}
      showMask
    />
  );
}

function TextMobileMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      //      mask={['(', /[0-9]/, /\d/, /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={"\u2000"}
      mask="(+99) - 99999 - 15 - 99999999"
      formatChars={{ "9": "[0-9]", "-": "[0-9-]", "?": "[0-9 ]" }}
      placeholderChar={"\u2000"}
      showMask
    />
  );
}

const ITEM_HEIGHT = 48;

const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  formSelect: {
    minWidth: 120,
    margin: "0px",
    marginTop: "11px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  },
  SwitchLabel: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.75rem"
    }
  }
}));

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    fontSize: "0.75rem"
  };
}

const BasicData = ({
  type,
  onChange,
  disabled,
  value,
  error,
  children,
  title,
  basic_data,
  provider_data,
  isProvider,
  provider_types,
  client_types,
  onDelete,
  onProvidersAsyncChange,
  onProvidersAsyncSearch,
  providers_autocomplete,
  client_groups,
  users,
  client_tiers,
  ...props
}) => {
  const handleChange = event => {
    onChange(event, "basic_data");
  };

  const handleProvidersAsyncChange = (event, values) => {
    onProvidersAsyncChange(event, values);
  };

  const handleProvidersAsyncSearch = (event, values) => {
    onProvidersAsyncSearch(event, values);
  };

  const theme = useTheme();

  const handleDelete = (type, value) => {
    if (disabled) {
      return;
    }

    onDelete(type, value);
  };

  const onMouseDown = e => {
    e.stopPropagation();
  };

  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var isEmailValid = re.test(String(basic_data.email).toLowerCase());

  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      {basic_data.hansa_code ? (
        <TextField
          id="hansa_code"
          name="hansa_code"
          label="Código de Hansa"
          disabled={true}
          type="text"
          value={basic_data.hansa_code}
          margin="normal"
          className="mr-2 "
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { fontSize: "0.75rem" } }}
        />
      ) : (
        ""
      )}
      {basic_data.sap_code ? (
        <TextField
          id="sap_code"
          name="sap_code"
          label="Código SAP"
          disabled={true}
          type="text"
          value={basic_data.sap_code}
          margin="normal"
          className="mr-2 "
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { fontSize: "0.75rem" } }}
        />
      ) : (
        ""
      )}
      {basic_data.sap_dimension ? (
        <TextField
          id="sap_dimension"
          name="sap_dimension"
          label="Dimension SAP"
          disabled={true}
          type="text"
          value={basic_data.sap_dimension}
          margin="normal"
          className="mr-2 "
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { fontSize: "0.75rem" } }}
        />
      ) : (
        ""
      )}
      <TextField
        id="business_name"
        name="business_name"
        label="Razón social"
        disabled={disabled || (isProvider && !basic_data.is_main_provider)}
        error={
          error !== "" && basic_data.business_name === ""
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && basic_data.business_name === ""
            ? "Debe completar este valor"
            : ""
        }
        type="text"
        required
        placeholder="Ingrese la razón social"
        onChange={handleChange}
        value={basic_data.business_name}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      <TextField
        id="fantasy_name"
        name="fantasy_name"
        label="Nombre comercial"
        disabled={disabled}
        required
        error={
          error !== "" && basic_data.fantasy_name === ""
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && basic_data.fantasy_name === ""
            ? "Debe completar este valor"
            : ""
        }
        type="text"
        placeholder="Ingrese el nombre comercial"
        onChange={handleChange}
        value={basic_data.fantasy_name}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      {isProvider ? (
        <FormControlLabel
          className={classes.SwitchLabel}
          control={
            <Switch
              id="is_main_provider"
              value={basic_data.is_main_provider}
              checked={basic_data.is_main_provider}
              disabled={disabled || basic_data.hansa_code !== ""}
              onChange={e => {
                handleChange(e);
              }}
              name="is_main_provider"
              size="small"
              color="primary"
              className="mr-4 mt-1"
            />
          }
          label="Es Casa Central?"
          labelPlacement="top"
        />
      ) : (
        ""
      )}
      {isProvider &&
      basic_data.hansa_code === "" &&
      basic_data.is_main_provider === false ? (
        <Autocomplete
          id="provider"
          style={{ width: 200, display: "inline-block", marginTop: "30px" }}
          getOptionLabel={option =>
            option.business_name +
            " (" +
            (option.contact ? option.contact.hansa_code : "") +
            ")"
          }
          getOptionSelected={(option, value) => option.business_name === value}
          options={providers_autocomplete.options}
          loading={providers_autocomplete.loading}
          onInputChange={handleProvidersAsyncSearch}
          onChange={handleProvidersAsyncChange.bind(this)}
          //value={providers_autocomplete.options.find(v => v.business_name === providers_autocomplete.provider.business_name) || {}}
          autoComplete
          noOptionsText={
            <Typography variant="caption">Sin resultados</Typography>
          }
          name="provider"
          includeInputInList
          className="mr-2"
          classes={{
            option: classes.option
          }}
          renderInput={params => (
            <TextField
              {...params}
              placeholder="Ingrese un proveedor"
              error={
                error !== "" &&
                basic_data.is_main_provider === false &&
                basic_data.hansa_code === ""
                  ? "Debe completar este campo"
                  : false
              }
              helperText={
                error !== "" &&
                basic_data.is_main_provider === false &&
                basic_data.hansa_code === ""
                  ? "Debe completar este valor"
                  : ""
              }
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {providers_autocomplete.loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                )
              }}
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
              inputProps={{
                ...params.inputProps,
                style: { fontSize: "0.75rem", width: 70 }
              }}
            />
          )}
        />
      ) : (
        ""
      )}

      {isProvider ? (
        <React.Fragment>
          <FormControl
            required
            className={classes.formSelect}
            inputProps={{ shrink: true }}
          >
            <Typography className={classes.typography}>
              Tipo de proveedor
            </Typography>
            <Select
              labelId="demo-mutiple-chip-label"
              id="provider_provider_types"
              name="provider_provider_types"
              className="mr-2"
              style={{ minWidth: 100 }}
              onClick={e => e.preventDefault()}
              multiple
              error={
                error !== "" && basic_data.provider_provider_types.length === 0
                  ? "Debe completar este campo"
                  : false
              }
              value={basic_data.provider_provider_types}
              onChange={e => {
                handleChange(e);
              }}
              disabled={disabled}
              input={<Input id="select-multiple-chip" />}
              renderValue={selected => (
                <div className={classes.chips}>
                  {selected.map(value => (
                    <Chip
                      key={value}
                      label={value}
                      className={classes.chip}
                      tabIndex={-1}
                      clickeable={true}
                      onDelete={
                        provider_data.types !== null &&
                        provider_data.types !== undefined
                          ? provider_data.types.find(o => o.type.name === value)
                            ? e => {
                                handleDelete("provider_provider_types", value);
                              }
                            : false
                          : ""
                      }
                      onMouseDown={e => {
                        onMouseDown(e);
                      }}
                    />
                  ))}
                </div>
              )}
              MenuProps={MenuProps}
            >
              {provider_types.map(provider_type => (
                <MenuItem
                  key={provider_type.id}
                  data-id={provider_type.id}
                  dataid={provider_type.id}
                  id={provider_type.id}
                  value={provider_type.name}
                  style={getStyles(
                    provider_type.name,
                    provider_type.name,
                    theme
                  )}
                >
                  <Checkbox
                    className="pr-4"
                    color="primary"
                    checked={
                      basic_data.provider_provider_types.indexOf(
                        provider_type.name
                      ) > -1
                    }
                    style={{ height: 0, width: 0 }}
                  />
                  {provider_type.group === provider_type.name
                    ? provider_type.group
                    : provider_type.group + " - " + provider_type.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText
              id="provider_provider_types_helper_text"
              style={{ color: "red" }}
            >
              {error !== "" && basic_data.provider_provider_types.length === 0
                ? "Debe completar este valor"
                : ""}
            </FormHelperText>
          </FormControl>
          <FormControlLabel
            className={classes.SwitchLabel}
            control={
              <Switch
                id="unusual_provider"
                value={basic_data.unusual_provider}
                checked={basic_data.unusual_provider}
                disabled={disabled}
                onChange={e => {
                  handleChange(e);
                }}
                name="unusual_provider"
                size="small"
                color="primary"
                className="mr-4 mt-1"
              />
            }
            label="Taller no habitual?"
            labelPlacement="top"
          />
          <FormControlLabel
            className={classes.SwitchLabel}
            control={
              <Switch
                id="contact_checked"
                value={basic_data.contact_checked}
                checked={basic_data.contact_checked}
                disabled={disabled}
                onChange={e => {
                  handleChange(e);
                }}
                name="contact_checked"
                size="small"
                color="primary"
                className="mr-4 mt-1"
              />
            }
            label="Datos chequeados?"
            labelPlacement="top"
          />
          <TextField
            id="contact_checked_date"
            name="contact_checked_date"
            type="date"
            label="Fecha de ult validación"
            disabled={disabled}
            required
            onChange={handleChange}
            value={basic_data.contact_checked_date}
            margin="normal"
            className="mr-2 mt-3"
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          />
        </React.Fragment>
      ) : (
        <FormControl
          className={classes.formControl}
          style={{ marginTop: "16px", marginRight: "16px", minWidth: "150px" }}
        >
          <InputLabel style={{ fontSize: "0.75rem" }}>
            Tipo de Cliente
          </InputLabel>
          <Select
            labelId="demo-mutiple-chip-label"
            id="client_type_id"
            name="client_type_id"
            required
            className="mr-2"
            style={{ minWidth: 100, fontSize: "0.75rem" }}
            onClick={e => e.preventDefault()}
            error={
              error !== "" && basic_data.client_type_id.length === 0
                ? "Debe completar este campo"
                : false
            }
            value={basic_data.client_type_id}
            onChange={e => {
              handleChange(e);
            }}
            disabled={disabled}
            input={<Input id="select-multiple-chip" />}
            MenuProps={MenuProps}
          >
            {client_types.map(client_type => (
              <MenuItem
                key={client_type.id}
                data-id={client_type.id}
                dataid={client_type.id}
                id={client_type.id}
                value={client_type.id}
                style={{ fontSize: "0.75rem" }}
              >
                {client_type.name}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText
            id="client_type_id_helper_text"
            style={{ color: "red" }}
          >
            {error !== "" && basic_data.client_type_id.length === 0
              ? "Debe completar este valor"
              : ""}
          </FormHelperText>
        </FormControl>
      )}

      {!isProvider ? (
        <FormControl
          className={classes.formControl}
          inputProps={{ shrink: true }}
        >
          <InputLabel style={{ fontSize: "0.75rem" }}>Categoría</InputLabel>
          <Select
            labelId="demo-mutiple-chip-label"
            id="client_tier_id"
            name="client_tier_id"
            className="mr-2"
            style={{ minWidth: 100, fontSize: "0.75rem" }}
            onClick={e => e.preventDefault()}
            value={basic_data.client_tier_id}
          >
            {client_tiers.map(client_tier => (
              <MenuItem
                key={client_tier.id}
                data-id={client_tier.id}
                dataid={client_tier.id}
                id={client_tier.id}
                value={client_tier.id}
              >
                {client_tier.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        ""
      )}
      <TextField
        id="email"
        name="email"
        disabled={disabled}
        required
        label="Email"
        type="email"
        placeholder="Ingrese el email"
        onChange={handleChange}
        value={basic_data.email}
        error={
          error !== "" && (basic_data.email === "" || isEmailValid === false)
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && (basic_data.email === "" || isEmailValid === false)
            ? "Debe completar este valor correctamente"
            : ""
        }
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <FormControl
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Telefono fijo *</Typography>
        <Input
          id="phone"
          name="phone"
          disabled={disabled}
          placeholder="Ingrese el teléfono fijo"
          margin="normal"
          className="mr-2"
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          value={basic_data.phone}
          onChange={handleChange}
          inputComponent={TextMaskCustom}
        />
      </FormControl>

      <FormControl
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Telefono móvil</Typography>
        <Input
          id="mobile"
          disabled={disabled}
          name="mobile"
          placeholder="Ingrese el teléfono móvil"
          margin="normal"
          className="mr-2"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          value={basic_data.mobile}
          onChange={handleChange}
          inputComponent={TextMobileMaskCustom}
        />
      </FormControl>

      <TextField
        id="web"
        disabled={disabled}
        name="web"
        label="Sitio web"
        type="text"
        placeholder="Ingrese el sitio institucional"
        onChange={handleChange}
        value={basic_data.web}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      {!isProvider ? (
        <React.Fragment>
          <FormControl
            className={classes.formControl}
            style={{
              marginTop: "16px",
              marginRight: "16px",
              minWidth: "150px"
            }}
          >
            <InputLabel style={{ fontSize: "0.75rem" }}>Grupo</InputLabel>
            <Select
              labelId="demo-mutiple-chip-label"
              id="client_group_id"
              name="client_group_id"
              className="mr-2"
              style={{ minWidth: 100, fontSize: "0.75rem" }}
              onClick={e => e.preventDefault()}
              value={basic_data.client_group_id}
              onChange={e => {
                handleChange(e);
              }}
              disabled={disabled}
              input={<Input id="select-multiple-chip" />}
              MenuProps={MenuProps}
            >
              {client_groups.map(group => (
                <MenuItem
                  key={group.id}
                  data-id={group.id}
                  dataid={group.id}
                  id={group.id}
                  value={group.id}
                  style={{ fontSize: "0.75rem" }}
                >
                  {group.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            className={classes.formControl}
            style={{
              marginTop: "16px",
              marginRight: "16px",
              minWidth: "150px"
            }}
          >
            <InputLabel style={{ fontSize: "0.75rem" }}>Vendedor</InputLabel>
            <Select
              labelId="demo-mutiple-chip-label"
              id="vendor_user_id"
              name="vendor_user_id"
              className="mr-2"
              style={{ minWidth: 100, fontSize: "0.75rem" }}
              onClick={e => e.preventDefault()}
              value={basic_data.vendor_user_id}
              onChange={e => {
                handleChange(e);
              }}
              disabled={disabled}
              input={<Input id="select-multiple-chip" />}
              MenuProps={MenuProps}
            >
              {users.map(user => (
                <MenuItem
                  key={user.id}
                  data-id={user.id}
                  dataid={user.id}
                  id={user.id}
                  value={user.id}
                  style={{ fontSize: "0.75rem" }}
                >
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            className={classes.formControl}
            style={{
              marginTop: "16px",
              marginRight: "16px",
              minWidth: "150px"
            }}
          >
            <InputLabel style={{ fontSize: "0.75rem" }}>Operador</InputLabel>
            <Select
              labelId="demo-mutiple-chip-label"
              id="operator_user_id"
              name="operator_user_id"
              className="mr-2"
              style={{ minWidth: 100, fontSize: "0.75rem" }}
              onClick={e => e.preventDefault()}
              value={basic_data.operator_user_id}
              onChange={e => {
                handleChange(e);
              }}
              disabled={disabled}
              input={<Input id="select-multiple-chip" />}
              MenuProps={MenuProps}
            >
              {users.map(user => (
                <MenuItem
                  key={user.id}
                  data-id={user.id}
                  dataid={user.id}
                  id={user.id}
                  value={user.id}
                  style={{ fontSize: "0.75rem" }}
                >
                  {user.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {!isProvider && userHasRole("web-administrative-admin") ? (
            <FormControl
              className={classes.formControl}
              style={{
                marginTop: "16px",
                marginRight: "16px",
                minWidth: "150px"
              }}
            >
              <InputLabel style={{ fontSize: "0.75rem" }}>
                Cliente de riesgo?
              </InputLabel>
              <Select
                labelId="demo-mutiple-chip-label"
                id="|_client"
                name="is_risk_client"
                className="mr-2"
                style={{ minWidth: 100, fontSize: "0.75rem" }}
                onClick={e => e.preventDefault()}
                value={basic_data.is_risk_client}
                onChange={e => {
                  handleChange(e);
                }}
                disabled={disabled}
                input={<Input id="select-multiple-chip" />}
                MenuProps={MenuProps}
              >
                <MenuItem
                  key={0}
                  data-id={0}
                  dataid={0}
                  id={0}
                  value={0}
                  style={{ fontSize: "0.75rem" }}
                >
                  No
                </MenuItem>
                <MenuItem
                  key={1}
                  data-id={1}
                  dataid={1}
                  id={1}
                  value={1}
                  style={{ fontSize: "0.75rem" }}
                >
                  Si
                </MenuItem>
              </Select>
            </FormControl>
          ) : (
            ""
          )}

          {!isProvider && (
            <>
              <FormControl
                className={classes.formControl}
                style={{
                  marginTop: "16px",
                  marginRight: "16px",
                  minWidth: "150px"
                }}
              >
                <InputLabel style={{ fontSize: "0.75rem" }}>
                  Orden de compra requerida?
                </InputLabel>
                <Select
                  labelId="demo-mutiple-chip-label"
                  id="purchase_order_required"
                  name="purchase_order_required"
                  className="mr-2"
                  style={{ minWidth: 100, fontSize: "0.75rem" }}
                  onClick={e => e.preventDefault()}
                  value={basic_data.purchase_order_required}
                  onChange={e => {
                    handleChange(e);
                  }}
                  disabled={disabled}
                  input={<Input id="select-multiple-chip" />}
                  MenuProps={MenuProps}
                >
                  <MenuItem
                    key={0}
                    data-id={0}
                    dataid={0}
                    id={0}
                    value={0}
                    style={{ fontSize: "0.75rem" }}
                  >
                    No
                  </MenuItem>
                  <MenuItem
                    key={1}
                    data-id={1}
                    dataid={1}
                    id={1}
                    value={1}
                    style={{ fontSize: "0.75rem" }}
                  >
                    Si
                  </MenuItem>
                </Select>
              </FormControl>
              {basic_data.purchase_order_required === 1 ? (
                <FormControl
                  className={classes.formControl}
                  style={{
                    marginTop: "16px",
                    marginRight: "16px",
                    minWidth: "150px"
                  }}
                >
                  <InputLabel style={{ fontSize: "0.75rem" }}>
                    Tipo de orden de compra
                  </InputLabel>
                  <Select
                    labelId="demo-mutiple-chip-label"
                    id="purchase_order_open"
                    name="purchase_order_open"
                    className="mr-2"
                    style={{ minWidth: 100, fontSize: "0.75rem" }}
                    onClick={e => e.preventDefault()}
                    value={basic_data.purchase_order_open}
                    onChange={e => {
                      handleChange(e);
                    }}
                    disabled={disabled}
                    input={<Input id="select-multiple-chip" />}
                    MenuProps={MenuProps}
                  >
                    <MenuItem
                      key={0}
                      data-id={0}
                      dataid={0}
                      id={0}
                      value={0}
                      style={{ fontSize: "0.75rem" }}
                    >
                      A demanda
                    </MenuItem>
                    <MenuItem
                      key={1}
                      data-id={1}
                      dataid={1}
                      id={1}
                      value={1}
                      style={{ fontSize: "0.75rem" }}
                    >
                      Abierta
                    </MenuItem>
                  </Select>
                </FormControl>
              ) : (
                ""
              )}

              {basic_data.purchase_order_required === 1 &&
              basic_data.purchase_order_open === 1 ? (
                <TextField
                  id="purchase_order"
                  name="purchase_order"
                  label="Orden de compra"
                  type="text"
                  placeholder="Ingrese la orden de compra"
                  onChange={handleChange}
                  value={basic_data.purchase_order}
                  margin="normal"
                  className="mr-2 "
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
                />
              ) : (
                ""
              )}
              {basic_data.purchase_order_required === 1 &&
              basic_data.purchase_order_open === 1 ? (
                <TextField
                  id="purchase_order_due_date"
                  name="purchase_order_due_date"
                  type="date"
                  label="Fecha de vencimiento"
                  onChange={handleChange}
                  value={basic_data.purchase_order_due_date}
                  margin="normal"
                  className="mr-2 mt-3"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
                />
              ) : (
                ""
              )}
              {basic_data.purchase_order_required === 1 &&
              basic_data.purchase_order_open === 1 ? (
                <NumberFormat
                  disabled={disabled}
                  placeholder="Ingrese el monto"
                  label="Monto"
                  name="purchase_order_amount"
                  className="mt-3 mr-2"
                  InputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                  value={
                    basic_data.purchase_order_amount !== "0"
                      ? basic_data.purchase_order_amount
                      : null
                  }
                  //            value={commercial_data.discount}
                  onChange={handleChange}
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix={"$"}
                  customInput={TextField}
                  InputLabelProps={{
                    shrink: true
                  }}
                  isAllowed={values => {
                    let { floatValue } = values;
                    floatValue = floatValue !== undefined ? floatValue : 0;
                    return floatValue >= 0;
                  }}
                />
              ) : (
                ""
              )}
            </>
          )}

          {/*        <TextField
          id="classification"
          disabled={disabled}
          name="classification"
          label="Clasificación"
          type="text"
          placeholder="Ingrese la clasificación"
          onChange={handleChange}
          value={basic_data.classification}
          margin="normal"
          className="mr-2 "
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
        />        
      */}
        </React.Fragment>
      ) : (
        ""
      )}
      {!isProvider && basic_data.provider_id ? (
        <div className="my-auto">
          <Link href={`/provider/edit/${basic_data.provider_id}`}>
            <ViewIcon />
            Proveedor rebate
          </Link>
        </div>
      ) : null}
    </React.Fragment>
  );
};

BasicData.defaultProps = {
  type: "text",
  className: "",
  isProvider: true,
  provider_types: [],
  disabled: false
};

BasicData.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default BasicData;
